'use strict';

class BlockArrowDown {

	constructor($target) {

		//Private properties
		$target;

        let arrowBtn = $target.find('.block_arrow__btn-down');
  
        $(arrowBtn).each((index, value) => {
        
            $(value).on("click", function (e) {
                let parent = $(value).parent().parent().parent().next();
    
                $(".blog-post").animate({ opacity : 0}, 800, () => {

                    window.fullPageInstance.moveTo(3);
                    
                })

            });
    
        });


		return {

			//Public properties
            

			publicBlockArrowDown:function(string){


			}

		}

	}

}

export default BlockArrowDown;